var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#515864",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), "s", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5c0 .825-.675 1.5-1.5 1.5S8 17.325 8 16.5 8.675 15 9.5 15s1.5.675 1.5 1.5zm-1.5-6c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S11 12.825 11 12s-.675-1.5-1.5-1.5zm0-4.5C8.675 6 8 6.675 8 7.5S8.675 9 9.5 9 11 8.325 11 7.5 10.325 6 9.5 6zM14 9c.825 0 1.5-.675 1.5-1.5S14.825 6 14 6s-1.5.675-1.5 1.5S13.175 9 14 9zm0 1.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm0 4.5c-.825 0-1.5.675-1.5 1.5S13.175 18 14 18s1.5-.675 1.5-1.5S14.825 15 14 15z"
  })));
}
export default SvgDragDrop;